import React, { useState, useEffect } from "react";
import { KeyValue } from "../../common/models";
import orgDataService from "services/orgDataService";
import { CardContent, CardHeader, FormControl, InputLabel, MenuItem, Select, Skeleton, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import hubsService from "services/hubsService";
import MDButton from "components/MDButton";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { toast } from "react-toastify";

const HubEditCard = ({ hub, setHub, getHub, isLoading, setIsEdit }) => {
  const [dispatchProcsses, setDispatchProcesses] = useState<KeyValue[]>([]);
  const [shiftDataSources, setShiftDataSources] = useState<KeyValue[]>([]);
  const [locationServiceTypes, setLocationServiceTypes] = useState<KeyValue[]>([]);
  const [errors, setErrors] = useState(undefined);

  useEffect(() => {
    orgDataService.getShiftDataSources().then((data) => setShiftDataSources(data));
    orgDataService.getDispatchProcesses().then((result) => setDispatchProcesses(result));
    orgDataService.getLocationServiceTypes().then((result) => setLocationServiceTypes(result));
  }, []);

  const save = () => {
    if (
      !hub.hubErail?.erailCompanyAccountId &&
      (hub?.hubErail?.erailMvrSku || hub?.hubErail?.erailBgreportSku || hub?.hubErail?.erailPrograms)
    )
    {
      setErrors({ erailCompanyAccountId: "ErailCompanyAccountId is required." });
      return;
    }

    hubsService
      .updateHub({
        id: hub!.id,
        dispatchProcessId: hub!.dispatchProcessId,
        groupEmail: hub?.groupEmail,
        fuelCardAccountNumber: hub?.fuelCardAccountNumber,
        shiftDataSourceId: hub?.shiftDataSourceId,
        erailCompanyAccountId: hub?.hubErail?.erailCompanyAccountId,
        erailMvrSku: hub?.hubErail?.erailMvrSku,
        erailPrograms: hub?.hubErail?.erailPrograms,
        erailBgreportSku: hub?.hubErail?.erailBgreportSku,
        locationServiceTypeId: hub?.locationServiceTypeId,
        rcxLocId: hub?.rcxLocId,
      })
      .then(() => {
        toast.success("Hub Updated");
        getHub();
        setIsEdit(false);
      });
  };

  return (
    <>
      {isLoading ? (
        <Skeleton variant="rectangular" width="98%" height="400px" sx={{ mx: 1, borderRadius: 3 }}></Skeleton>
      ) : (
        <Card>
          <CardHeader title="Details"></CardHeader>
          <CardContent>
            <MDBox component="form" pb={3} px={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                  <TextField
                    value={hub.fuelCardAccountNumber}
                    inputProps={{ maxLength: 20 }}
                    label="Fuel Card Account Number"
                    onChange={(e) => setHub({ ...hub, fuelCardAccountNumber: e.target.value })}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                  <TextField
                    value={hub.groupEmail}
                    inputProps={{ maxLength: 255 }}
                    label="Group Email"
                    onChange={(e) => setHub({ ...hub, groupEmail: e.target.value })}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl sx={{ minWidth: 120 }} fullWidth>
                    <InputLabel id="hubId">Hub Dispatch Method</InputLabel>
                    <Select
                      id="dispatchProcessId"
                      name="dispatchProcessId"
                      labelId="dispatchProcessId"
                      label="Hub Dispatch Method"
                      sx={{ minWidth: 210 }}
                      value={hub.dispatchProcessId}
                      onChange={(e) => setHub({ ...hub, dispatchProcessId: +e.target.value })}
                      displayEmpty
                    >
                      {dispatchProcsses &&
                        dispatchProcsses.map((h, index) => {
                          return (
                            <MenuItem key={index} value={h.id}>
                              {h.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl sx={{ minWidth: 120 }} fullWidth>
                    <InputLabel id="shiftDataSourceId">Shift Data Source</InputLabel>
                    <Select
                      id="shiftDataSourceId"
                      name="shiftDataSourceId"
                      labelId="shiftDataSourceId"
                      label="Shift Data Sourcer"
                      value={hub.shiftDataSourceId}
                      onChange={(e: any) => setHub({ ...hub, shiftDataSourceId: +e.target.value })}
                    >
                      {shiftDataSources &&
                        shiftDataSources.map((s, index) => {
                          return (
                            <MenuItem key={index} value={s.id}>
                              {s.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    value={hub.hubErail?.erailCompanyAccountId || ""}
                    inputProps={{ maxLength: 255 }}
                    label="Erail Company Account Id"
                    onChange={(e) =>
                      setHub({ ...hub, hubErail: { ...hub.hubErail, erailCompanyAccountId: e.target.value } })
                    }
                    fullWidth
                    error={!!errors?.erailCompanyAccountId}
                    helperText={errors?.erailCompanyAccountId}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    value={hub.hubErail?.erailMvrSku || ""}
                    inputProps={{ maxLength: 255 }}
                    label="Erail MVR SKU"
                    onChange={(e) => setHub({ ...hub, hubErail: { ...hub.hubErail, erailMvrSku: e.target.value } })}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    value={hub.hubErail?.erailBgreportSku || ""}
                    inputProps={{ maxLength: 255 }}
                    label="Erail Bgreport SKU"
                    onChange={(e) =>
                      setHub({ ...hub, hubErail: { ...hub.hubErail, erailBgreportSku: e.target.value } })
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    value={hub.hubErail?.erailPrograms || ""}
                    inputProps={{ maxLength: 255 }}
                    label="Erail Programs"
                    onChange={(e) => setHub({ ...hub, hubErail: { ...hub.hubErail, erailPrograms: e.target.value } })}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl sx={{ minWidth: 120 }} fullWidth>
                    <InputLabel id="locationServiceType">Location Service Type</InputLabel>
                    <Select
                      id="locationServiceTypeId"
                      name="locationServiceTypeId"
                      labelId="locationServiceTypeId"
                      label="Location Service Type"
                      value={hub.locationServiceTypeId}
                      onChange={(e: any) => setHub({ ...hub, locationServiceTypeId: +e.target.value })}
                    >
                      {locationServiceTypes &&
                        locationServiceTypes.map((s, index) => {
                          return (
                            <MenuItem key={index} value={s.id}>
                              {s.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    value={hub.rcxLocId || ""}
                    inputProps={{ maxLength: 255 }}
                    label="RCX Loc Id"
                    onChange={(e) => setHub({ ...hub, rcxLocId: +e.target.value })}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} justifyItems="space-between">
                  <Grid container spacing={2}>
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                      <MDButton variant="text" color="secondary" onClick={() => setIsEdit(false)} component={Link}>
                        Cancel
                      </MDButton>
                      <MDButton variant="contained" color="dark" onClick={save}>
                        Save
                      </MDButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </MDBox>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default HubEditCard;
